import { render, staticRenderFns } from "./WebsiteDepartmentList.vue?vue&type=template&id=6cdcba1e&scoped=true&"
import script from "./WebsiteDepartmentList.vue?vue&type=script&lang=js&"
export * from "./WebsiteDepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteDepartmentList.vue?vue&type=style&index=0&id=6cdcba1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcba1e",
  null
  
)

export default component.exports